import { render, staticRenderFns } from "./imgLibrary.vue?vue&type=template&id=0bdbfc36&scoped=true&"
import script from "./imgLibrary.vue?vue&type=script&lang=js&"
export * from "./imgLibrary.vue?vue&type=script&lang=js&"
import style0 from "./imgLibrary.vue?vue&type=style&index=0&id=0bdbfc36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdbfc36",
  null
  
)

export default component.exports